import React from 'react';
import { Container, Typography, Paper } from '@mui/material';

const useStyles = {
  container: {
    marginTop: '2rem',
    marginBottom:'2rem'
  },
  paper: {
    padding: '1.5rem',
  },
};

const TermsAndConditions = () => {
  return (
    <Container style={useStyles.container}>
      <Paper style={useStyles.paper}>
        <Typography variant="h4" gutterBottom>
          Terms and Conditions
        </Typography>

        <Typography paragraph>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin
          convallis cursus lectus, vel facilisis turpis sodales vel. Vivamus
          suscipit velit id nunc vestibulum fringilla. Proin eu ligula non
          urna ultrices congue. Proin vel lorem sed urna fermentum sodales vel
          ac lacus. Vestibulum vel justo id est faucibus consequat. Suspendisse
          potenti. Fusce et magna pulvinar, vestibulum ligula vel, viverra
          turpis.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Section 1: Nulla facilisi
        </Typography>

        <Typography paragraph>
          Curabitur nec malesuada justo. Integer aliquet sodales lectus vitae
          varius. In hac habitasse platea dictumst. Sed id interdum lectus, ut
          aliquam urna. Nulla facilisi. Proin quis convallis quam.
        </Typography>
        
        {/* Add more terms and conditions as needed */}

        <Typography variant="h6" gutterBottom>
          Section 2: Nunc non odio
        </Typography>

        <Typography paragraph>
          Nunc vestibulum, quam nec accumsan malesuada, ipsum elit pharetra
          felis, at ullamcorper diam justo eu lectus. Suspendisse potenti.
          Integer quis ante vel turpis posuere eleifend. Duis vel libero in
          ligula fermentum tristique. Quisque ut mauris nec lectus gravida
          bibendum.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Your use of this website
        </Typography>

        <Typography paragraph>
          Ut egestas, turpis nec varius fringilla, purus elit sodales turpis,
          ut tincidunt sapien augue eu risus. Sed eget ex a libero cursus
          commodo.
        </Typography>
      </Paper>
    </Container>
  );
};

export default TermsAndConditions;
